import React from 'react';
import './WhatsAppButton.css';
import { useLanguage } from '../../../context/LanguageContext';

interface WhatsAppButtonProps {
  phoneNumber?: string;
  message?: string;
  className?: string;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  phoneNumber = '+905346690042',
  message,
  className = ''
}) => {
  const { t } = useLanguage();
  const effectiveMessage = message ?? t('whatsapp.default');
  const handleWhatsAppClick = () => {
    const formattedPhone = phoneNumber.replace(/\s+/g, '').replace('+', '');
    const encodedMessage = encodeURIComponent(effectiveMessage);
    const whatsappUrl = `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      className={`whatsapp-button ${className}`}
      onClick={handleWhatsAppClick}
      aria-label={t('contact.whatsapp.cta')}
      title={t('contact.whatsapp.cta')}
    >
      <i className="fab fa-whatsapp" aria-hidden="true"></i>
      <span className="whatsapp-button__text">{t('contact.info.whatsapp')}</span>
    </button>
  );
};

export default WhatsAppButton;